import { ApiModule, type PaginatedResponseData } from '@common/index';
import type { ReasonForAbsenceItem, ReasonForAbsence } from '../models';

export class ReasonForAbsenceApi extends ApiModule {
  protected endpoint = '/reason-for-absence';

  public async pageReasonForAbsences(params: any) {
    return this.api.post<PaginatedResponseData<ReasonForAbsenceItem>, any>(
      `${this.endpoint}/page?page=${params.page}&size=${params.itemsPerPage}&sort=${params.sort ?? ''}`,
      {
        ...params
      }
    );
  }

  public loadReasonForAbsenceDetails(id: number) {
    return this.api.get<ReasonForAbsence>(`${this.endpoint}?id=${id}`);
  }

  public saveReasonForAbsence(params: any) {
    return this.api.post(`${this.endpoint}`, {
      ...params
    });
  }

  public deleteReasonForAbsence(id: number) {
    return this.api.delete(`${this.endpoint}?id=${id}`);
  }
}
